<template>
    <ui-field :label="label" :name="name" :error="error" :warning="warning" :info="info" v-slot="{ id }">
        <v-select
            :id="id"
            class="ui-select-searchable"
            :class="cssClasses+' '+selectClass"
            :options="mutableOptions"
            :create-option="createOption"
            :multiple="multiple"
            :taggable="!! createOption"
            :push-tags="!! createOption"
            :label="optionLabel"
            :value="mutableValue"
            @input="val => $emit('input', val)"
            @change="val => $emit('change', val)"
            @search="onSearch"
        >
            <template #no-options>
                <slot name="no-options">{{ mutableNoOption }}</slot>
            </template>
            <template #option="scope" v-if="$scopedSlots.option">
                <slot name="option" v-bind="scope"></slot>
            </template>
            <template #selected-option="scope" v-if="$scopedSlots['selected-option']">
                <slot name="selected-option" v-bind="scope"></slot>
            </template>
        </v-select>
    </ui-field>
</template>

<script>
import vSelect from "vue-select"

export default {
    components: { vSelect },
    props: {
        value: null,
        selectClass: '',
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        required: Boolean,
        hideChevron: Boolean,
        field: String,

        // VSelect Options.
        options: { type: Array, default: () => [] },
        search: Function,
        searchDebounce: { type: Number, default: 350 },
        multiple: Boolean,
        optionLabel: String,
        noOption: { type: String, default: 'Sorry, no matching options.' },
        noSearch: { type: String, default: 'Type to search...' },
        createOption: Function,
        taggable: Boolean,
        pushTags: Boolean,
    },
    computed:{
      cssClasses(){
        const additionals = this.hideChevron ? 'hideChevrons ' : ' '
        return this.field+' '+additionals
      }
    },
    data () {
        return {
            mutableValue: this.value,
            mutableNoOption: this.search ? this.noSearch : this.noOption,
            mutableOptions: this.options,
            debouncedSearch: _.debounce(async (loading, search) => {
                try {
                    this.mutableOptions = await this.search(search)
                } finally {
                    loading(false)
                }
            }, this.searchDebounce)
        }
    },
    methods: {
        onSearch(search, loading) {
            if (! this.search) return
            loading(true)
            this.mutableNoOption = this.noOption
            this.debouncedSearch(loading, search)
        },
    },
    watch: {
        options (newOptions) {
            this.mutableOptions = newOptions
        },
        value(value) {
            this.mutableValue = value
        },
    },
}
</script>

<style lang="scss">
.v-select.ui-select-searchable .dropdown-toggle {
    background-color: #FFF;
    padding: 4px;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    border: 1px solid rgb(209, 213, 219);
}
.v-select.ui-select-searchable .dropdown-toggle:focus-within {
    outline: 2px solid transparent;
    outline-offset: 2px;
    position: relative;
    z-index: 10;
    --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: #2563eb;
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    border-color: #2563eb;
}
.v-select.ui-select-searchable.hideChevrons .open-indicator{
  display:none;
}
</style>
